/**
 * Created by rak on 1/11/2016.
 */
'use strict';
angular.module('betosyswebapp').controller('sideBarCtrl', function ($scope, $location, $timeout) {

  $scope.menu = [
    {
      label: 'nav.menuOptions.dashboard',
      iconClasses: 'fa fa-map-marker',
      url: '#/track'
    },
    {
      label: 'nav.menuOptions.driverDashboard',
      iconClasses: 'fa fa-truck',
      url: '#/driverdashboard'
    },
    {
      label: 'nav.menuOptions.portalCommand',
      iconClasses: 'fa fa-pencil-square-o',
      url: '#/portalcommand'
    },
    {
      label: 'nav.menuOptions.maps',
      iconClasses: 'fa fa-globe',
      children: [{
        label: 'nav.menuOptions.mapsSubMenu.lastLocation',
        iconClasses: 'fa fa-location-arrow',
        url: '#/mapping/last'

      }, {
        label: 'Vehicle Map',
        iconClasses: 'fa fa-truck',
        url: '#/mapping/device'
      }, {
        label: 'nav.menuOptions.mapsSubMenu.groupMap',
        iconClasses: 'fa fa-sitemap',
        url: '#/mapping/fleet'
      }, {
        label: 'nav.menuOptions.mapsSubMenu.sosEmergencyMap',
        iconClasses: 'fa fa-ambulance',
        url: '#/mapping/panic'

      }, {
        label: 'nav.menuOptions.mapsSubMenu.freeDeviceMap',
        iconClasses: 'fa fa-hand-paper-o',
        url: '#/mapping/idle'

      }, {
        label: 'nav.menuOptions.mapsSubMenu.busyDeviceMap',
        iconClasses: 'fa fa-usd',
        url: '#/mapping/busy'

      }]
    },

    {
      label: 'nav.menuOptions.reports',
      iconClasses: 'fa fa-list-alt',
      children: [{
        label: 'nav.menuOptions.reportsSubMenu.vehicleDetails',
        iconClasses: 'fa fa-location-arrow',
        url: '#/reports/vehicle.detail'

      }, {
        label: 'nav.menuOptions.reportsSubMenu.groupDetails',
        iconClasses: 'fa fa-sitemap',
        url: '#/reports/group.detail'
      }, {
        label: 'nav.menuOptions.reportsSubMenu.groupSummary',
        iconClasses: 'fa fa-sitemap',
        url: '#/reports/group.summary'
      }, {
        label: 'nav.menuOptions.reportsSubMenu.performance',
        iconClasses: 'fa fa-stethoscope',
        url: '#/reports/performance'

      }]
    },
    {
      label: 'nav.menuOptions.admin',
      iconClasses: 'fa fa-list-alt',
      children: [{
        label: 'nav.menuOptions.telephone',
        iconClasses: 'fa fa-phone',
        url: '#/telephone/list'
      }, {
        label: 'nav.menuOptions.contacts',
        iconClasses: 'fa fa-phone',
        url: '#/contact/list'
      }]

    }];
  var setParent = function (children, parent) {
    angular.forEach(children, function (child) {
      child.parent = parent;
      setParent(child.children, child);
    });
  };

  $scope.findItemByUrl = function (children, url) {
    for (var i = 0, length = children.length; length > i; i++) {
      if (children[i].url && children[i].url.replace('#', '') === url) {
        return children[i];
      }
      if (void 0 !== children[i].children) {
        var item = $scope.findItemByUrl(children[i].children, url);
        if (item) {
          return item;
        }
      }
    }
  };

  setParent($scope.menu, null);
  $scope.openItems = [];
  $scope.selectedItems = [];
  $scope.selectedFromNavMenu = !1;
  $scope.select = function (item) {
    if (item.open) {
      return void (item.open = !1);
    }
    for (var i = $scope.openItems.length - 1; i >= 0; i--) {
      $scope.openItems[i].open = !1;
      $scope.openItems = [];
    }

    for (var parentRef = item; null !== parentRef;) {
      parentRef.open = !0;
      $scope.openItems.push(parentRef);
      parentRef = parentRef.parent;
      if (!item.children || item.children && item.children.length < 1) {
        $scope.selectedFromNavMenu = !0;
        for (var j = $scope.selectedItems.length - 1; j >= 0; j--) {
          $scope.selectedItems[j].selected = !1;
        }
        $scope.selectedItems = [];
        for (parentRef = item; null !== parentRef;) {
          parentRef.selected = !0;
          $scope.selectedItems.push(parentRef);
          parentRef = parentRef.parent;
        }

      }
    }

  };

  $scope.$watch(function () {
    return $location.path();
  }, function (newVal) {
    if (!$scope.selectedFromNavMenu) {
      var item = $scope.findItemByUrl($scope.menu, newVal);
      if (item) {
        $timeout(function () {
          $scope.select(item);
        });
      }
    }
    $scope.selectedFromNavMenu = !1;
  });

});




// WEBPACK FOOTER //
// ./.tmp/components/sidebar/sideBarController.js